import Tooltip from "@mui/material/Tooltip";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import clsx from "clsx";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider.jsx";
import { FormContext } from "../context/FormProvider.jsx";
import * as Messages from "../messages/messages.js";
import "./styles/date-range-field.css";
import "./styles/new-text.css";

const DateRangeField = ({
  idProp,
  label,
  val,
  state,
  setState,
  debouncedSave,
  setIsLoading,
  disabledInput,
}) => {
  const [open, setOpen] = useState(false);

  const { requestStatus, handleInputDisable } = useContext(FormContext);

  const { userId } = useContext(DashboardContext);

  const getDateString = (date) => {
    return dayjs(new Date(date)).format("M/D/YYYY");
  };

  const handleDateChange = (newVal) => {
    let newState = {};
    if (!newVal[0] && !newVal[1]) {
      newState = {
        ...state,
        [`${idProp}Start`]: "",
        [`${idProp}Complete`]: "",
      };
      // Clear the date range
      setState(newState);

      if (debouncedSave && setIsLoading) {
        setIsLoading(true);
        debouncedSave.mutate(newState);
      }
      return;
    }

    const selectedStartDate = newVal[0] ? dayjs(newVal[0]["$d"]) : null;
    const selectedCompleteDate = newVal[1] ? dayjs(newVal[1]["$d"]) : null;

    let startDate, completeDate;

    if (
      selectedStartDate &&
      selectedCompleteDate &&
      selectedStartDate.isAfter(selectedCompleteDate)
    ) {
      startDate = getDateString(selectedCompleteDate);
      completeDate = getDateString(selectedStartDate);
    } else {
      startDate = selectedStartDate ? getDateString(selectedStartDate) : val[0];
      completeDate = selectedCompleteDate
        ? getDateString(selectedCompleteDate)
        : val[1];
    }

    newState = {
      ...state,
      [`${idProp}Start`]: startDate,
      [`${idProp}Complete`]: completeDate,
    };

    setState(newState);

    if (debouncedSave && setIsLoading && requestStatus !== "A") {
      setIsLoading(true);
      debouncedSave.mutate(newState);
    }
  };

  return (
    <div className="info-activities-container">
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
        <DateRangePicker
          className="date-range-picker"
          localeText={{
            start: `${label} Start`,
            end: `${label} Complete`,
          }}
          calendars={1}
          value={val}
          onChange={handleDateChange}
          disabled={
            handleInputDisable(idProp, state, disabledInput, userId) === true
              ? true
              : false
          }
          defaultValue={[
            dayjs(state.startDate ? state.startDate : new Date()),
            dayjs(state.endDate ? state.endDate : new Date()),
          ]}
          minDate={dayjs(state.startDate ? state.startDate : "2017-01-01")}
          slotProps={{
            field: {
              id: "date-range",
              className: "date-field",
            },
            textField: {
              className: "date-form-control",
              id: "date-text-input",
              variant: "outlined",
              classes: {
                formControl: "date-range-form",
                inputLabel: "date-range-label",
              },
              InputProps: {
                className: "date-outlined",
                classes: {
                  root: "date-field-root",
                  notchedOutline: "date-notched",
                },
              },
            },
            fieldSeparator: {
              id: "date-separator",
              className: "date-separator",
            },
            popper: {
              id: "date-range-popper",
            },
            desktopPaper: {
              id: "date-range-desktop-paper",
            },
            layout: {
              id: "date-range-layout",
              className: "date-range-layout",
              classes: {
                contentWrapper: "date-range-content-wrapper",
              },
            },
            calendarHeader: {
              className: "date-range-calendar-header",
              id: clsx("date-range-calendar-header"),
              classes: {
                viewTransitionContainer: "date-range-transition-container",
              },
            },
            switchViewButton: {
              id: "date-range-switch-view-btn",
            },
            day: {
              id: "date-range-calendar-day",
            },
            actionBar: {
              className: "date-range-action-bar",
              id: "date-range-action-bar",
              actions: ["clear"],
            },
            clearButton: {
              id: "date-range-clear-btn",
              classes: { root: "date-range-clear-btn" },
              onClick: () => {
                console.log("Clearing date range");
                let newState = {
                  ...state,
                  [`${idProp}Start`]: null,
                  [`${idProp}Complete`]: null,
                };
                setState(() => newState);
              },
            },
          }}
        />
      </LocalizationProvider>
      <Tooltip
        id="tf-tooltip"
        classes={{
          tooltip: "text-field-tooltip",
          popper: "text-field-popper",
          arrow: "text-field-arrow",
          tooltipPlacementLeft: "text-field-right",
        }}
        title={Messages[`${idProp}Message`]}
        placement="top"
        arrow
        open={open}
      >
        <InfoCircle
          className="text-info-circ"
          id={`info-${idProp}`}
          color="white"
          size={30}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        />
      </Tooltip>
    </div>
  );
};

export default DateRangeField;
